import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { CalendarPage } from '@/features/settings/ui/CalendarPage';

export const Route = createFileRoute('/_authenticated/settings/calendar')({ validateSearch: z.object({ s: sortSearchParam }), component: CalendarPage });
